import { render, staticRenderFns } from "./PageBreadcrumb.vue?vue&type=template&id=0bf93eea&scoped=true"
import script from "./PageBreadcrumb.vue?vue&type=script&lang=js"
export * from "./PageBreadcrumb.vue?vue&type=script&lang=js"
import style0 from "./PageBreadcrumb.vue?vue&type=style&index=0&id=0bf93eea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf93eea",
  null
  
)

export default component.exports